import { AccountCircle } from "@mui/icons-material";
import { Avatar, Typography } from "@mui/material";
import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import useService from "../../../../../hooks/useService";
import { useEffect, useState } from "react";
import STRINGS from "../utils/strings";

const InformationHeaderContainer = () => {
  const currentUserService = inject("current-user-service");
  const userRepository = useService("repositories/user-repository");
  const [userInfo, setUserInfo] = useState({});
  const userId = currentUserService?.user?.pk;
  const userName = userInfo?.name ?? STRINGS.defaultUserName;
  const userRole = userInfo?.role ?? STRINGS.defaultUserRole;
  const userProfilePicture = userInfo?.profilePicture ?? null;

  const fetchUserData = async () => {
    const data = await userRepository.findRecord(userId);
    setUserInfo(data);
  };

  useEffect(() => {
    if (!userId || !userRepository) return;
    fetchUserData();
  }, [userId, userRepository]);

  return (
    <div className="w-full flex flex-row justify-between h-[10%]">
      <div className="flex flex-row content-start justify-start">
        <Avatar
          className="w-[75px] h-[75px] text-gray-400 bg-white m-2"
          alt=""
          src={userProfilePicture}
        >
          {userProfilePicture && (
            <AccountCircle className="w-full h-full bg-white p-0 m-0" />
          )}
        </Avatar>
        <div className="py-4 flex flex-col">
          <Typography className="text-black font-semibold text-base p-0">
            {userName}
          </Typography>
          <Typography className="text-blue-700 font-normal text-2xl p-0">
            {userRole}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default InformationHeaderContainer;
